<span *ngIf="showTopOwner" class="badge badge-pill" [class.badge-dark]="theme === 'dark'" [class.badge-light]="theme === 'light'">
  <i class="icon-rubbl"></i>
  {{ this.text }}
</span>
